import {
  DeleteCommentResponseDTO,
  GetListCommentByUserResponseDTO,
  GetListCommentResponseDTO,
  GetListRepliesCommentResponseDTO,
  PatchCommentResponseDTO,
  PostCommentReactResponseDTO,
  PostCreateCommentResponseDTO,
  PostUserBlockResponseDTO
} from '@twygs/shared/publisher-interface';
import axiosInstance from './axios-instance';

export type CreateCommentDTO = {
  articleId: string;
  nodeId: string;
  content: any; // Lexical JSON content
  parentCommentId?: string;
  userId?: string;
  quote?: string;
  isPublishProfile?: boolean;
};

export type UpdateCommentDTO = {
  commentId: string;
  content: any; // Lexical JSON content
};
export const commentApi = {
  getComments: async (articleId, nodeId, isGeneral, limit, page, userId, notificationCommentId) => {
    const { data }: GetListCommentResponseDTO = await axiosInstance.get(
      '/api/v1/publisher/comments',
      {
        params: {
          articleId,
          nodeId,
          isGeneral,
          limit,
          page,
          userId,
          notificationCommentId
        }
      }
    );
    return data;
  },

  getCommentsByUser: async (nodeId, limit, page, userId) => {
    const { data }: GetListCommentByUserResponseDTO = await axiosInstance.get(
      '/api/v1/publisher/comments/by-user',
      {
        params: {
          nodeId,
          userId,
          limit,
          page
        }
      }
    );
    return data;
  },

  getRelevantComments: async (articleId, nodeId, isGeneral, limit, page, userId) => {
    const { data }: GetListCommentResponseDTO = await axiosInstance.get(
      '/api/v1/publisher/comments/relevant',
      {
        params: {
          articleId,
          nodeId,
          isGeneral,
          limit,
          page,
          userId
        }
      }
    );
    return data;
  },

  getGeneralComments: async (articleId, isGeneral, limit, page, userId) => {
    const { data }: GetListCommentResponseDTO = await axiosInstance.get(
      '/api/v1/publisher/comments',
      {
        params: {
          articleId,
          // paragraphId,
          isGeneral,
          limit,
          page,
          userId
        }
      }
    );
    return data;
  },

  getReplies: async (commentId, userId, pagination, notificationRepliedId) => {
    const { data }: GetListRepliesCommentResponseDTO = await axiosInstance.get(
      `/api/v1/publisher/comments/${commentId}/replies`,
      {
        params: {
          limit: pagination.limit,
          page: pagination.page,
          userId,
          notificationRepliedId
        }
      }
    );
    return data;
  },

  getReportOptions: async () => {
    const { data } = await axiosInstance.get('/api/v1/publisher/reports/options');
    return data;
  },

  reportComment: async ({
    targetId,
    targetType,
    optionIds,
    detail
  }: {
    targetId: string;
    targetType: string;
    optionIds: (string | number)[];
    detail?: string;
  }) => {
    const { data } = await axiosInstance.post('/api/v1/publisher/reports', {
      targetId,
      targetType,
      optionIds,
      detail
    });
    return data;
  },

  blockUser: async (userId: string) => {
    const { data }: PostUserBlockResponseDTO = await axiosInstance.post(
      `/api/v1/publisher/user/${userId}/block`
    );
    return data;
  },

  createComment: async (comment: CreateCommentDTO) => {
    const { data }: PostCreateCommentResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/comments',
      comment
    );
    return data;
  },

  createGeneralComment: async (comment: CreateCommentDTO) => {
    const { data }: PostCreateCommentResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/comments',
      comment
    );
    return data;
  },

  deleteComment: async (commentId: string) => {
    const { data }: DeleteCommentResponseDTO = await axiosInstance.delete(
      `/api/v1/publisher/comments/${commentId}`
    );
    return data;
  },

  updateComment: async ({ commentId, content }: UpdateCommentDTO) => {
    const { data }: PatchCommentResponseDTO = await axiosInstance.patch(
      `/api/v1/publisher/comments/${commentId}`,
      {
        content
      }
    );
    return data;
  },

  reactToComment: async ({
    commentId,
    nodeId,
    reactionType,
    isLike
  }: {
    commentId: string;
    nodeId: string;
    reactionType: string;
    isLike: boolean;
  }) => {
    const { data }: PostCommentReactResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/comments/react',
      {
        commentId,
        nodeId,
        reactionType,
        isLike
      }
    );
    return data;
  },

  getCommentReactionBreakdown: async (commentId: string) => {
    const { data } = await axiosInstance.get(
      `/api/v1/publisher/comments/${commentId}/reactions`
    );
    return data;
  },

  getCommentReactionUsers: async (commentId: string, options: { reactionType?: string; page?: number; limit?: number }) => {
    const { data } = await axiosInstance.get(
      `/api/v1/publisher/comments/${commentId}/reactions/users`,
      {
        params: {
          reactionType: options.reactionType,
          page: options.page || 1,
          limit: options.limit || 20
        }
      }
    );
    return data;
  }
};
